//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sortBy } from 'lodash-es';
import fractionToDecimal from '~/utils/fraction-to-decimal';
export default {
  data: () => ({
    cards: [],
  }),
  async fetch() {
    const data = await this.$content('services').fetch();
    const items = sortBy(
      data.map((item) => ({
        ...item,
        pos: fractionToDecimal(item.pos),
      })),
      ['pos'],
    ).reverse();
    this.cards = items.slice(0, 4);
  },
};
